import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../layout/Layout";
import { Card, Row, Col, Table, Button } from "react-bootstrap";

function KnowledgeDetail() {
  const { id } = useParams();

  // Mock data (ileride API'den gelecek)
  const problem = {
    id,
    reportType: "Şikayet Raporu",
    number: "#3492",
    plannedDate: "2024-09-20",
    realizedDate: "2024-09-17",
    date: "2024-09-15",
    company: "Bambi",
    contactPerson: "Selin Gürbüz",
    responsibleDepartman: "Bakım Departmanı",
    reasonTitle: "2x50x50 profillerde yüzey pürüzlülüğü",
    size: "2x50x50x4000",
    quality: "Sıcak / S235",
    reasonPhotos: [
      "http://34.22.191.236:3003/public/CPrzCx1ahKimages-2.jpeg",
      "http://34.22.191.236:3003/public/JxmmxjFdGlundercu2t-welding-1.jpg",
    ],
    reason: [
      "50x50 profillerin yüzeyinde pürüzlülük, üretim sırasında malzeme kalitesizliği ve hatalı soğutma yöntemleri nedeniyle oluşmuştur.",
      "Yüzeydeki bu pürüzler müşteri şikayetlerine neden olmaktadır.",
    ],
    causeAnalysis:
      "Yüzey pürüzlülüğü, malzeme kalitesi ve soğutma yöntemlerinin yetersiz olmasından kaynaklanmaktadır.",
    actionDecisions:
      "Üretimde malzeme kalitesinin artırılması ve soğutma yöntemlerinin gözden geçirilmesi gerekiyor.",
    solutionPhotos: [
      "http://34.22.191.236:3003/public/d6NEoWcviqimages.jpeg",
    ],
    author: "Aylin Özdemir",
    price: "1200 $",
    loss: "120 Kg",
    return: "Yok",
  };

  return (
    <Layout>
      <Row className="g-4">
        {/* Sol içerik */}
        <Col lg={9}>
          <Card className="shadow-sm border-0 mb-4">
            <Card.Body>
              <h3 className="text-center fw-bold mb-4">
                {problem.reportType}
              </h3>
              <div className="d-flex justify-content-between mb-4">
                <div>
                  <p><b>Planlanan Tarih:</b> {problem.plannedDate}</p>
                  <p><b>Gerçekleşen Tarih:</b> {problem.realizedDate}</p>
                </div>
                <div className="text-end">
                  <p><b>No:</b> {problem.number}</p>
                  <p><b>Tarih:</b> {problem.date}</p>
                </div>
              </div>

              <hr />

              {/* Firma Bilgileri */}
              <Row className="mb-3">
                <Col md={8}>
                  <p><b>Firma:</b> {problem.company}</p>
                </Col>
                <Col md={4}>
                  <p><b>İlgili Kişi:</b> {problem.contactPerson}</p>
                  <p><b>Sorumlu Departman:</b> {problem.responsibleDepartman}</p>
                </Col>
              </Row>

              {/* Problem Tablosu */}
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Şikayetin Tanımı</th>
                    <th>Ebat</th>
                    <th>Kalite</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{problem.reasonTitle}</td>
                    <td>{problem.size}</td>
                    <td>{problem.quality}</td>
                  </tr>
                </tbody>
              </Table>

              {/* Şikayet Fotoğrafları */}
              <Row className="mb-3">
                {problem.reasonPhotos.map((src, i) => (
                  <Col key={i} md={4} className="mb-2">
                    <img src={src} alt="reason" className="img-fluid rounded" />
                  </Col>
                ))}
              </Row>

              {/* Açıklama */}
              <ul>
                {problem.reason.map((r, i) => (
                  <li key={i}>{r}</li>
                ))}
              </ul>

              {/* Neden Analizi */}
              <div className="p-3 my-3 bg-light rounded">
                <h6 className="text-center fw-bold">NEDEN ANALİZİ</h6>
                <p>{problem.causeAnalysis}</p>
              </div>

              {/* Aksiyon Kararları */}
              <div className="p-3 my-3 bg-light rounded">
                <h6 className="text-center fw-bold">AKSİYON KARARLARI</h6>
                <p>{problem.actionDecisions}</p>
                <Row>
                  {problem.solutionPhotos.map((src, i) => (
                    <Col key={i} md={6} className="mb-2">
                      <img
                        src={src}
                        alt="solution"
                        className="img-fluid rounded"
                      />
                    </Col>
                  ))}
                </Row>
              </div>

              <hr />
              <p><b>Rapor Yazarı:</b> {problem.author}</p>
            </Card.Body>
          </Card>
        </Col>

        {/* Sağ özet panel */}
        <Col lg={3}>
          <Card className="shadow-sm border-0 mb-3 p-3">
            <Button variant="primary" className="w-100 mb-3">
              İndir (PDF)
            </Button>
            <p><b>Maliyet:</b> {problem.price}</p>
            <p><b>Kayıp Miktarı:</b> {problem.loss}</p>
            <p><b>İade Durumu:</b> {problem.return}</p>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
}

export default KnowledgeDetail;
